import { axios } from '@Root/API'

export const get = (studyProgrammeId, courseRoleId) => {
	return axios.get(`program/${studyProgrammeId}/course-role/${courseRoleId}`)
}
